import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    id: null,
    name: null,
    email: null,
    phone: null,
    subscription_type: null,
    subscription_ends_at: null,
    paypal_subscription_id: null,
    email_verified_at: null,
    remember_token: null,
    is_admin: false,
    image: null,
    cover_image: null,
    token: null,
    permissions: [],
    is_new: false,
    open_onboard: false,
    tour_product: false,
    tour_checkout: false,
    tour_sales: false,
    open_support: false,
  },
};

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateUser: (state, data) => {
      return {
        value: {
          ...state.value,
          id: data.payload.id,
          name: data.payload.name,
          phone: data.payload.phone,
          email: data.payload.email,
          image: data.payload.image || null,
          cover_image: data.payload.cover_image || null,
          subscription_type: data.payload.subscription_type,
          subscription_ends_at: data.payload.subscription_ends_at,
          paypal_subscription_id: data.payload.paypal_subscription_id,
          email_verified_at: data.payload.email_verified_at,
          remember_token: data.payload.remember_token,
          is_new: data.payload.is_new,
          open_onboard: data.payload.is_new,
          tour_product: data.payload.tour_product,
          tour_checkout: data.payload.tour_checkout,
          tour_sales: data.payload.tour_sales,
          is_admin: data.payload.is_admin,
          permissions: data.payload.permissions,
        },
      };
    },
    updateUserToken: (state, data) => {
      return {
        value: {
          ...state.value,
          token: data.payload.token,
        },
      };
    },
    updateUserPermissions: (state, data) => {
      state.value.permissions = data.payload.permissions;
    },
    updateUserStatus: (state, data) => {
      state.value.is_new = data.payload.is_new;
    },
    updateOpenOnboard: (state, data) => {
      state.value.open_onboard = data.payload.open_onboard;
    },
    updateTourProduct: (state, data) => {
      state.value.tour_product = data.payload.tour_product;
    },
    updateTourCheckout: (state, data) => {
      state.value.tour_checkout = data.payload.tour_checkout;
    },
    updateTourSales: (state, data) => {
      state.value.tour_sales = data.payload.tour_sales;
    },
    updateOpenSupport: (state, data) => {
      state.value.open_support = data.payload.open_support;
    },
    clearUser: () => {
      return {
        ...initialState,
      };
    },
  },
});

export const { updateUser, updateUserToken, clearUser, updateUserPermissions, updateUserStatus, updateOpenOnboard, updateTourProduct, updateTourCheckout, updateTourSales, updateOpenSupport } = user.actions;

export default user.reducer;
